import React from 'react'
import ReportList from '../../features/Report/ReportList'

function Report() {
  return (
    <ReportList />
  )
}

export default Report